var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"id":"updateSnack","bottom":"","right":"","value":_vm.updateExists,"timeout":-1},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"text":"","color":"var(--color-speak-view-btn-bg)"},on:{"click":_vm.refreshApp}},'v-btn',attrs,false),[_vm._v(" Update ")])]}}])},[_vm._v(" An update is available ")])}
var staticRenderFns = []

export { render, staticRenderFns }